// extracted by mini-css-extract-plugin
export default {"change_page":"pageNavigationButtons_change_page__MCL2a","arrow_botton":"pageNavigationButtons_arrow_botton__vJjby","list_page":"pageNavigationButtons_list_page__Kbmox"};